/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum RadioOptions {
    YES = 'Yes',
    NO = 'No',
    DONT_KNOW = 'Dont_Know',
}
